import { useTranslation } from "react-i18next";
import PageHeader from "../../components/common/pageheader/PageHeader";

const MyAccountPage = () => {
  const { t } = useTranslation();
  return (
    <div>
      <PageHeader title={t("stubs.myAccountTitle")} />
      <p>{t("stubs.myAccountPlaceholder")}</p>
    </div>
  );
};

export default MyAccountPage;
